import { Response, apiAbortController } from '@ui/src';
import { StatementListItem } from '../../list/types';
import { Category } from '../../../charts/types';

import api from '../../../../api/api';

export const statementsListApi = api.injectEndpoints({
  endpoints: (build) => ({
    getStatementsList: build.query<Response<StatementListItem>, string>({
      query: (query) => ({
        url: `/v1/statements-items${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getStatementsGL: build.query<
      { data: StatementListItem[] },
      {
        id: string;
        query: string;
      }
    >({
      query: (data) => ({
        url: `/v1/statements-items/${data.id}/general-ledger?all=true${data.query} `,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportSelectedStatements: build.query<string, string>({
      query: (query) => ({
        url: `/v1/statements-items?format=csv&all=true${query}`,
        responseHandler: (response) => response.text(),
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getStatementsAccountsCategories: build.query<Response<Category>, string>({
      query: (query) => ({
        url: `/v1/accounts-categories?${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getStatementPdf: build.query<any, { id: string; query: string }>({
      query: (data) => ({
        url: `/v1/statements-items/${data.id}/pdf?${data.query}`,
        responseHandler: (response) => {
          let responseFormatted;

          if (response.status !== 200) {
            responseFormatted = response.json();
          } else {
            responseFormatted = response.blob();
          }

          return responseFormatted;
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getStatementItemsFile: build.query<
      { data: any },
      { query: string; type: string }
    >({
      query: (data) => ({
        url: `/v1/statements-items/${data.type}?${data.query}`,
        responseHandler: (response) => {
          let responseFormatted;

          if (response.status !== 200) {
            responseFormatted = response.json();
          } else {
            responseFormatted = response.blob();
          }

          return responseFormatted;
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetStatementsListQuery,
  useLazyGetStatementsGLQuery,
  useGetStatementsListQuery,
  useLazyExportSelectedStatementsQuery,
  useGetStatementsAccountsCategoriesQuery,
  useLazyGetStatementPdfQuery,
  useLazyGetStatementItemsFileQuery,
} = statementsListApi;

export const {
  endpoints: {
    getStatementsList,
    exportSelectedStatements,
    getStatementsGL,
    getStatementPdf,
    getStatementItemsFile,
  },
} = statementsListApi;
